import Script from 'next/script';

import { TOKENS } from '@/settings/tokens';

type Props = {
  children: React.ReactElement;
};

const ScriptLoader = ({ children }: Props): React.ReactElement => (
  <>
    {/* eslint-disable-next-line @next/next/no-before-interactive-script-outside-document */}
    <Script
      // POCKET.js
      src='https://dnnsjdj5swfc3.cloudfront.net/front-end/libs/pocket.latest.js'
      strategy='beforeInteractive'
    />
    <script
      dangerouslySetInnerHTML={{
        __html: `window.POCKET_ENV = ${JSON.stringify({
          mixpanel: TOKENS.mixpanel,
        })}`,
      }}
    />
    {children}
  </>
);

export default ScriptLoader;
